import { Box, Flex } from '@chakra-ui/react';
import type { LHCDetails } from '@diamond/shared/types';
import { Button, Text } from '@diamond/shared/ui';
import { formatLhcDate } from '@diamond/shared/utils';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { formatCurrency } from '../../api/mappers';

interface LHCDetailSummaryProps {
  lhc: LHCDetails;
}

function SummaryItem({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) {
  return (
    <Box minW={{ base: '120px', md: '148px' }} flex="1">
      <Text fontSize="xs" color="gray.500" mb={1}>
        {label}
      </Text>
      <Text fontSize="md" fontWeight="semibold">
        {value}
      </Text>
    </Box>
  );
}

export function LHCDetailSummary({ lhc }: LHCDetailSummaryProps) {
  return (
    <Flex
      align={{ base: 'flex-start', lg: 'center' }}
      justify="space-between"
      mb={6}
      gap={6}
      flexWrap={{ base: 'wrap', xl: 'nowrap' }}
    >
      <Flex gap={10} flexWrap="wrap">
        <SummaryItem label="Tgl. LHC" value={formatLhcDate(lhc.lhc_date)} />
        <SummaryItem label="Plant" value={lhc.plant_name || '-'} />
      </Flex>

      <Flex
        align={{ base: 'stretch', md: 'center' }}
        gap={6}
        w={{ base: 'full', xl: 'auto' }}
      >
        <Flex
          border="1px solid"
          borderColor="gray.200"
          borderRadius="lg"
          px={6}
          py={4}
          gap={6}
          flexWrap={{ base: 'wrap', xl: 'nowrap' }}
          w={{ base: 'full', xl: 'auto' }}
        >
          <SummaryItem
            label="Jumlah Faktur"
            value={lhc.total_invoice_count ?? 0}
          />
          <SummaryItem
            label="Total nilai Faktur (Billing)"
            value={formatCurrency(lhc.total_invoice_amount)}
          />
          <SummaryItem
            label="Total Mutasi"
            value={formatCurrency(lhc.total_mutation_amount)}
          />
          <SummaryItem
            label="Total OP/KB"
            value={formatCurrency(lhc.total_difference_amount)}
          />
        </Flex>

        <Button
          variant="ghost"
          bg="gray.100"
          _hover={{ bg: 'gray.200' }}
          w={{ base: 'full', sm: '144px' }}
          h="48px"
          gap={2}
          borderRadius="8px"
          py={1}
          px={4}
          flexShrink={0}
          fontSize="14px"
          fontWeight="semibold"
          display="flex"
          justifyContent="center"
          alignItems="center"
          leftIcon={<FileDownloadIcon fontSize="small" />}
        >
          Export LHC
        </Button>
      </Flex>
    </Flex>
  );
}
